/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../../hook/use-api-handler";
import { logger } from "../../utils/logger";

const useLeavePolicyService = () => {
    const [employmentType, setEmploymentType] = useState([]);
    const [adminLeaveListsInfo, setAdminLeaveListsInfo] = useState([]);

    const { fetchData } = useAPIHandler();

    async function employmentTypeLists() {
        try {
            const URL = `/organization/get-organization-benefit`;
            const METHOD = "GET";

            try {
                const result = await fetchData({
                    url: URL,
                    method: METHOD,
                });

                if (result?.status === "success" && result?.data) {
                    const employmentType = result.data.employmentType || [];

                    if (result.data.isProvisionPeriod) {
                        if (!employmentType.includes("probationary")) {
                            employmentType.push("probationary");
                        }
                    }
                    setEmploymentType(result?.data?.employmentType)
                }
            } catch (err) {
                console.error("Error fetching organizations:", err);
            }
        } catch (error) {
            logger.log(error)
        }
    }

    async function adminLeaveLists() {
        try {
            const URL = `/admin/leave-type?pageSize=30`;
            const METHOD = "GET";

            try {
                const result = await fetchData({
                    url: URL,
                    method: METHOD,
                });

                
                const mappedData = result?.data?.leaveType?.map((item) => ({
                    id: item?.leave_type_id,
                    name: item?.leave_type_name
                }));
                // mappedData = mappedData.filter((item) => item.name !== 'LOP' && item.name !== 'Sanction Leave');
                // mappedData = mappedData.filter((item) => item.name !== 'Sanction Leave');
                setAdminLeaveListsInfo(mappedData);
            } catch (err) {
                console.error("Error fetching organizations:", err);
            }
        } catch (error) {
            logger.log(error)
        }
    }
    

    useEffect(() => {
        employmentTypeLists();
        adminLeaveLists()
    }, []);

    return {
        employmentType,
        adminLeaveListsInfo
    }
}

export default useLeavePolicyService;